import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';

// Import pages
import Dashboard from './pages/Dashboard';
import AffinityData from './pages/AffinityData';
import SfdcData from './pages/SfdcData';
import DataWarehouse from './pages/DataWarehouse';
import Reports from './pages/Reports';
import DataQA from './pages/DataQA';
import DataAnalysisHygiene from './pages/DataAnalysisHygiene';

// Create a theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/affinity" element={<AffinityData />} />
            <Route path="/sfdc" element={<SfdcData />} />
            <Route path="/dwh" element={<DataWarehouse />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/qa" element={<DataQA />} />
            <Route path="/analysis-hygiene" element={<DataAnalysisHygiene />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;